import styled from 'styled-components'
import { Link } from 'react-router-dom'
import FontAwesome from 'react-fontawesome'

export const PlantListHeader = styled.div`
    height: 56px;
    width: 100%;
    position: fixed;
    top: 0;
    background-color: var(--navbar-bg-color);
    z-index: 1100;
`

export const SearchCancel = styled.div`
    line-height: 60px;
    padding-left: 0px;
    color: #fff;
`

export const SearchClear = styled(FontAwesome)`
    position: absolute;
    top: 20px;
    right: 25px;
    color: gray;
`

export const PlantListSearch = styled.input`
    height: 30px;
    background-color: #fff;
    border-radius: 20px;
    border: none;
    position: relative;
    margin-top: 14px; 
`

export const PlantListItem = styled(Link)`
    margin: 0;
    min-height: 80px;
    border-bottom: 1px solid var(--ios-bg-color);
    color: #000;
    
    &:hover {
        color: #000;
    }
`

export const PlantListItemImage = styled.img`
    height: 80px;
    display: inline-block;
    object-fit: ${props => (props.objectFit ? props.objectFit : 'cover')};
    padding: 0 15px 0 0;
`

export const PlantListItemContent = styled.div`
    display: inline-block;
    padding: 10px 0;
    position: relative;
`

export const PlantListItemName = styled.div`
    font-size: 1.1rem;
    line-height: 30px;
    margin-right: ${props => (props.showPlain ? '0' : '45px')};
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const PlantListItemLatinName = styled.div`
    font-size: 0.9rem;
    font-weight: 300;
    color: var(--secondary);
    line-height: 30px;
    margin-right: ${props => (props.showPlain ? '0' : '45px')};
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const PlantListItemAction = styled.img`
    position: absolute;
    top: 27px;
    right: 15px;
    width: 25px;
    height: 25px;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Plants/PlantList.js